export const ProdConfig = {
  production: true,
  backend_url: 'https://certifysimple-graphql.herokuapp.com/v1/graphql',
  backend_ws_url: 'wss://certifysimple-graphql.herokuapp.com/v1/graphql',
  frontend_url: 'https://zensteri.web.app',
  cloudront_url: 'https://d1niz8ad8nu5h5.cloudfront.net',
  image_bucket: 'edropin-images-1',
}